import { FelaCSS, FelaCSSWithCustomSelectors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSSWithCustomSelectors;
  image: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    height: '100%',
    width: '100%',
  },
  image: {
    height: '100%',
    width: '100%',
    objectFit: 'cover',
  },
});

export default styles;
